<template>
    <b-container fluid>
        <vue-toastr ref="toastr" />
        <div :class="{blur: loading}">
            <b-row>
                <b-col>
                    <b-alert variant="warning" show>
                        <b>Внимание!</b>
                        <span class="small">Идет консолидация финансовой информации с другими серсвиами. На этапе консолидации возможно отображение не всей информации о платежах.</span>
                    </b-alert>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-card title="Последние платежи">
                        <b-table v-if="hasPayments" :items="payments" :fields="historyFields"></b-table>
                        <p v-else>
                            Платежей нет
                        </p>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div v-if="loading" class="loading-container">
            <data-loading></data-loading>
        </div>
    </b-container>
</template>

<script>
    import DataLoading from '@/containers/DataLoading.vue'
    import Toastr from 'vue-toastr'

    export default {
        name: 'finance-history',
        components: {
            'data-loading': DataLoading,
            'vue-toastr': Toastr
        },
        data () {
            return {
                loading: false,

                payments: [],
                historyFields: {
                    date: {
                        label: 'Дата',
                        tdClass: 'small'
                    },
                    amount: {
                        label: 'Сумма',
                        formatter: amount => '€ ' + amount
                    },
                    service: {
                        label: 'Сервис',
                        tdClass: 'small',
                        formatter: service => {
                            let result

                            switch (service) {
                            case 'post':
                                result = 'Profi-Post.org'
                                break
                            case 'host':
                                result = 'Profi-Host.org'
                                break
                            case 'link':
                                result = 'Profi-Link.org'
                                break
                            case 'spooo':
                                result = 'Spooo.ru'
                                break
                            case 'eterra':
                                result = 'eTerra.info'
                                break
                            default:
                                result = service
                            }

                            return result
                        }
                    },
                    method: {
                        label: 'Платежный шлюз',
                        tdClass: 'small',
                        formatter: service => {
                            let result

                            switch (service) {
                            case 'robokassa':
                                result = 'RoboKassa'
                                break
                            case 'wm':
                                result = 'WebMoney'
                                break
                            default:
                                result = ''
                            }

                            return result
                        }
                    },
                    comment: {
                        label: 'Примечание'
                    }
                }
            }
        },
        computed: {
            hasPayments () {
                return (this.payments.length > 0)
            }
        },
        mounted () {
            this.loadHistory()
        },
        methods: {
            loadHistory () {
                this.loading = true

                this.axios.get('finance/history')
                    .then(response => {
                        this.payments = response.data['history']

                        if (response.data.hasOwnProperty('message') && response.data['message']) {
                            this.$refs['toastr'].i(response.data['message'])
                        }

                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    })
                    .catch(() => {
                        this.$refs['toastr'].e('Произошла ошибка')
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// History.vue?fb65d242